var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsAddItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.1667V5.16667C16 2.86583 14.1342 1 11.8333 1H5.16667C2.86583 1 1 2.86583 1 5.16667V11.8333C1 14.1342 2.86583 16 5.16667 16H10.1667",
    stroke: "#D7D7D7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 10.1665V11.8332C15.9993 14.134 14.1335 15.9998 11.8327 15.9998H10.166",
    stroke: "#D7D7D7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16V15.1667C11 12.8658 12.8658 11 15.1667 11H16",
    stroke: "#D7D7D7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83398 8.50016H10.1673",
    stroke: "#D7D7D7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50065 10.1668V6.8335",
    stroke: "#D7D7D7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsAddItemIcon);
export default __webpack_public_path__ + "static/media/ms-add-item-icon.7af0b64cd230001631494f397c1ef16c.svg";
export { ForwardRef as ReactComponent };